import { render, staticRenderFns } from "./stars.vue?vue&type=template&id=62a2e65a&scoped=true&"
import script from "./stars.vue?vue&type=script&lang=ts&"
export * from "./stars.vue?vue&type=script&lang=ts&"
import style0 from "./stars.vue?vue&type=style&index=0&id=62a2e65a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a2e65a",
  null
  
)

export default component.exports